import {callAPI} from '@/store/utils'; // eslint-disable-line

export default {
  namespaced: true,
  state: {
    counterpartiesList: [],
    counterpartiesDDList: [],
  },
  mutations: {
    setCounterPartiesList(state, res) {
      state.counterpartiesList = res?.result?.data || [];
    },
    setCounterPartiesDDList(state, res) {
      state.counterpartiesDDList = res?.result || [];
    },
  },
  actions: {
    async actionCreateCounterParty({rootState}, params) {
      return await callAPI(
        'POST',
        `company/${rootState.companyId}/counterparty-and-accountCounterparty`,
        params,
      );
    },
    async actionGetCounterPartiesList({rootState, commit}, params) {
      const res = await callAPI(
        'POST',
        `company/${rootState.companyId}/counterparties`,
        params,
      );
      commit('setCounterPartiesList', res);
      return res;
    },
    async actionGetCounterPartiesDDList({commit, rootState}) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/counterpartiesDD`,
      );
      commit('setCounterPartiesDDList', res);
      return res;
    },
    async actionUpdateCounterParty({rootState}, params) {
      const res = await callAPI(
        'PUT',
        `company/${rootState.companyId}/counterparty/${params.cpId}`,
        params.counterparty,
      );
      return res;
    },
    async actionDeleteCounterParty({rootState}, cpId) {
      const res = await callAPI(
        'DELETE',
        `company/${rootState.companyId}/counterparty/${cpId}`,
      );
      return res;
    },
    async actionProcessUploadedFile({rootState}, params) {
      const res = await callAPI('POST', 'processCounterPartyUploadedFile', {
        params,
        id: rootState.companyId,
      });
      return res;
    },
    async actionCreateCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'POST',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty`,
        params,
      );
      return res;
    },
    async actionGetCounterPartyIbans({rootState}, params) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparties`,
      );
      return res;
    },
    async actionGetPaymentPurposeCodes({rootState}, params) {
      const query = new URLSearchParams({
        country: params.country,
        currency: params.currency,
        kind: params.kind,
      }).toString();
      return await callAPI(
        'GET',
        `company/${rootState.companyId}/equals/paymentPurposeCodes?${query}`,
      );
    },
    async actionGetCounterParty({rootState}, params) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/counterparty/${params.cpId}`,
      );
      return res;
    },
    async actionEditCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'PUT',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty/${params?.iban?.id}`,
        params.iban,
      );
      return res;
    },
    async actionSetDefaultCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'PUT',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty/${params.id}/setDefault`,
      );
      return res;
    },
    async actionDeleteCounterPartyIban({rootState}, params) {
      const res = await callAPI(
        'DELETE',
        `company/${rootState.companyId}/counterparty/${params.cpId}/accountCounterparty/${params.id}`,
      );
      return res;
    },
  },
};
